// import React, { useEffect, useState } from "react";
// import { labelUtils } from "../Util";
// import FormGroupWrapper from "./FormGroupWrapper";
// import Select from "react-select";
// import { useSelector, useDispatch } from "react-redux";
// import {
//   setProductFieldsJSON,
//   setProductVariantState,
// } from "../../../../slices/orders/orderSlice";
// import { getAllDropdownListItems } from "../../../../pages/Order/Orders/OrderService";
// import rootReducer from "../../../../store";
// import { setRendererFormState } from "../../../../slices/common/reducer";

// const CustomSelect = ({
//   arrEle,
//   newElfromJSON,
//   fieldEle,
//   formState,
//   displayLabelKey,
//   databaseKey,
// }) => {
//   const dispatch = useDispatch();
//   const selectError = useSelector(
//     (state) => state.common.formRendererValidation.select
//   );
//   const productFieldsJSON = useSelector(
//     (state) => state.order.ProductFieldsJSON
//   );
//   const abc = useSelector((state) => state.common.formRendererState);

//   const [options, setOptions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const detailsFieldJson = useSelector(
//     (state) => state.order.selectedOrders.detailsFieldJson
//   );

//   const dataCustomValue = fieldEle?.["data-customvalue"];
//   const datasourcelist = fieldEle?.["data-datasourcelist"];
//   const parentAttributeKey = fieldEle?.["parent-attributekey"];
//   const parentSelectedValue = formState[parentAttributeKey];
//   const key = databaseKey ? databaseKey : displayLabelKey;
//   const isRequired = fieldEle?.["display-required"] === 1;
//   const selectedOption = options.find(
//     (option) => option.value === formState[key] || option.value === "ACTIVE"
//   );
//   const isInvalid = isRequired && !selectedOption;
//   const validationClass = isInvalid ? "is-invalid" : "is-valid";

//   useEffect(() => {
//     if (!formState[key]) {
//       const activeOption = options.find(option => option.value === "ACTIVE");
//       const statusOption = options.find(option => option.value === "PROPOSAL-PENDING");
//       const freshOption = options.find(option => option.value === "FRESH");
//       if (activeOption) {
//         dispatch(setRendererFormState({ key, value: "ACTIVE" }));
//       }
//       if (statusOption) {
//         dispatch(setRendererFormState({ key, value: "PROPOSAL-PENDING" }));
//       }
//       if (freshOption) {
//         dispatch(setRendererFormState({ key, value: "FRESH" }));
//       }
//     }
//   }, [dispatch, formState, key, options]);

//   useEffect(() => {
//     const fetchOptions = async () => {
//       setLoading(true);
//       try {
//         if (datasourcelist) {
//           // const response = await getAllDropdownListItems(
//           //   datasourcelist,
//           //   productFieldsJSON,
//           //   "PPET",
//           //   abc.product_id,
//           //   "QUL",
//           //   parentSelectedValue
//           // );
//           if (response) {
//             const data = response;
//             if (Array.isArray(data)) {
//               const updatedOptions = data.map((item) => ({
//                 value: item.value || item.key,
//                 label: item.label || item.value || item.key,
//               }));
//               setOptions(updatedOptions);
//               const updatedProductFieldsJSON = {
//                 ...productFieldsJSON,
//                 [datasourcelist]: {
//                   ...productFieldsJSON[datasourcelist],
//                   "data-customvalue": updatedOptions,
//                 },
//               };
//               dispatch(setProductFieldsJSON(updatedProductFieldsJSON));
//             } else {
//               console.warn("Unexpected data format received:", data);
//             }
//           } else {
//             console.error(
//               "API Response is undefined or missing data property:",
//               response
//             );
//           }
//         } else {
//           let optArray = [];
//           if (typeof dataCustomValue === "string") {
//             optArray = dataCustomValue.split("#");
//           } else if (Array.isArray(dataCustomValue)) {
//             optArray = dataCustomValue;
//           }
//           const updatedOptions = optArray.map((opt) => ({
//             value: opt.value || opt.key || opt,
//             label: opt.label || opt.value || opt.key || opt,
//           }));
//           setOptions(updatedOptions);
//         }
//       } catch (error) {
//         console.error("Error fetching dropdown options:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOptions();
//   }, [detailsFieldJson, parentSelectedValue, dispatch, fieldEle]);

//   const selectedValue = formState[key] || "ACTIVE";

//   return (
//     <FormGroupWrapper
//       arrEle={arrEle}
//       newElfromJSON={newElfromJSON}
//       fieldEle={fieldEle}
//     >
//       <div
//         className={`form-group ${validationClass}`}
//         style={{ width: labelUtils.getElementWidth(fieldEle) }}
//       >
//         <Select
//           id={newElfromJSON}
//           onKeyDown={(e) => {
//             if (e.key === "Enter") {
//               e.preventDefault();
//             }
//           }}
//           name={key}
//           options={options}
//           placeholder={fieldEle?.["display-placeholder"]}
//           isDisabled={fieldEle?.["display-disabled"] === 1}
//           isRequired={isRequired}
//           value={
//             options.find((option) => option.value === selectedValue) || null
//           }
//           onChange={(e) => {
//             rootReducer.dispatch(setRendererFormState({ key, value: e.value }));
//           }}
//           className={validationClass}
//         />
//         {selectError && (
//           <div className="invalid-feedback">This field is required</div>
//         )}
//         {fieldEle?.["display-description"] && (
//           <div className="form-text text-muted formElementDesc">
//             {fieldEle?.["display-description"]}
//           </div>
//         )}
//       </div>
//     </FormGroupWrapper>
//   );
// };

// export default CustomSelect;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import FormGroupWrapper from "./FormGroupWrapper";
import { labelUtils } from "../Util";
import { getAllDropdownListItems } from "../../../../Utils/CommonService";
import { setProposalFieldsJSON } from "../../../../slices/orders/orderSlice";
import { setRendererFormState } from "../../../../slices/common/reducer";
import rootReducer from "../../../../store";

const CustomSelect = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState = {},
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const proposalFieldsJSON = useSelector(
    (state) => state.order.ProposalFieldsJSON
  );
  const dataCustomValue = fieldEle?.["data-customvalue"];
  const datasourcelist = fieldEle?.["data-datasourcelist"];
  const parentAttributeKey = fieldEle?.["parent-attributekey"];
  const key = databaseKey || displayLabelKey;
  const displayYes = fieldEle?.["display-yes"];
  const required = showRequired ? fieldEle?.["display-required"] === 1 : false;
  const parentSelectedValue = formState[parentAttributeKey];
  const detailsData = useSelector(
    (state) => state.order?.selectedOrders?.detailsData || {}
  );
  const data = useSelector(
    (state) => state.agMember?.selectedAgMember?.detailsData || {}
  );

  useEffect(() => {
    if (!formState[key]) {
      const activeOption = options.find((option) => option.value === "ACTIVE");
      const statusOption = options.find(
        (option) => option.value === "PROPOSAL-PENDING"
      );
      const freshOption = options.find((option) => option.value === "FRESH");
      if (activeOption) {
        dispatch(setRendererFormState({ key, value: "ACTIVE" }));
      }
      if (statusOption) {
        dispatch(setRendererFormState({ key, value: "PROPOSAL-PENDING" }));
      }
      if (freshOption) {
        dispatch(setRendererFormState({ key, value: "FRESH" }));
      }
    }
  }, [dispatch, formState, key, options]);

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        if (datasourcelist) {
          const response = await getAllDropdownListItems(
            datasourcelist,
            proposalFieldsJSON,
            "AGRP",
            detailsData.ag_id || data.parentid,
            "STA",
            parentSelectedValue
          );
          if (response) {
            const data = response;
            if (Array.isArray(data)) {
              const updatedOptions = data.map((item) => ({
                value: item.value || item.key,
                label: item.label || item.value || item.key,
              }));
              setOptions(updatedOptions);
              const updatedProfileFieldsJSON = {
                ...proposalFieldsJSON,
                [datasourcelist]: {
                  ...proposalFieldsJSON[datasourcelist],
                  "data-customvalue": updatedOptions,
                },
              };
              dispatch(setProposalFieldsJSON(updatedProfileFieldsJSON));
            } else {
              console.warn("Unexpected data format received:", data);
            }
          } else {
            console.error(
              "API Response is undefined or missing data property:",
              response
            );
          }
        } else {
          let optArray = [];
          if (typeof dataCustomValue === "string") {
            optArray = dataCustomValue.split("#");
          } else if (Array.isArray(dataCustomValue)) {
            optArray = dataCustomValue;
          }
          const updatedOptions = optArray.map((opt) => ({
            value: opt.value || opt.key || opt,
            label: opt.label || opt.value || opt.key || opt,
          }));
          setOptions(updatedOptions);
        }
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [
    datasourcelist,
    parentSelectedValue,
    dispatch,
    detailsData?.ag_id,
    data?.parentid,
  ]);

  useEffect(() => {
    if (required && (formState[key] === undefined || formState[key] === "")) {
      setError("This field is required");
    } else {
      setError("");
    }
  }, [formState, key, required, options]);

  const displayDependent = fieldEle?.["display-dependent"];

  // Visibility Logic
  let shouldDisplay = true;

  if (displayDependent) {
    const parentValue = formState[displayDependent];
    const displayIndex = fieldEle?.["display-index"];
    if (
      parentValue === undefined ||
      parentValue === null ||
      parentValue === ""
    ) {
      shouldDisplay = false;
    } else if (displayIndex !== undefined) {
      shouldDisplay = Number(parentValue) >= Number(displayIndex);
    } else {
      shouldDisplay = !!parentValue;
    }
  } else if (displayYes) {
    const parentValue = formState[displayYes];
    const legacyValues = ["yes", "other", "renewal", "active"];
    shouldDisplay = legacyValues.includes(
      parentValue?.toString().toLowerCase()
    );
  }

  useEffect(() => {
    if ((displayYes || displayDependent) && shouldDisplay === false) {
      rootReducer.dispatch(setRendererFormState({ key, value: "" }));
    }
  }, [displayYes, displayDependent, shouldDisplay, key]);

  useEffect(() => {
    if (
      !formState[key] &&
      fieldEle["parent-key"] &&
      formState[fieldEle["parent-key"]]
    ) {
      dispatch(
        setRendererFormState({
          key,
          value: formState[fieldEle["parent-key"]],
        })
      );
    }
  }, []);

  if (!shouldDisplay) {
    return null;
  }

  const handleChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    dispatch(setRendererFormState({ key, value }));
    setError("");
  };

  const handleBlur = () => {
    const fieldValue = formState[key];
    if (required && (fieldValue === undefined || fieldValue === "")) {
      setError("This field is required");
    } else {
      setError("");
    }
  };

   const shouldShowDesc =
    !fieldEle?.["display-desc-value"] ||
    String(formState[key])?.toLowerCase() ===
      String(fieldEle?.["display-desc-value"])?.toLowerCase();

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <div style={{ display: "none" }}>
          <input
            type="text"
            required={required}
            value={formState[key] || ""}
            onChange={(e) => handleChange({ value: e.target.value })}
          />
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : (
          <Select
            id={newElfromJSON}
            placeholder={
              fieldEle?.["display-placeholder"] || "Select"
            }
            value={
              options.find((option) => option.value === formState[key]) || null
            }
            onChange={handleChange}
            onBlur={handleBlur}
            isDisabled={fieldEle?.["display-disabled"] === 1}
            isClearable
            className="mandatory"
            options={options}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 1050 }) }}
          />
        )}

        {error && !formState[key] && (
          <div style={{ color: "red", fontSize: "12px" }}>{error}</div>
        )}

        {fieldEle?.["display-description"] && shouldShowDesc &&(
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default CustomSelect;
